__webpack_require__.p = "https://static.age.awaze.com/search-mfe/1dce0f1/_next/";